export const PROFILE_VIEWBOX_Y = 56

export default function WorkoutProfileThumbnail({ points }) {
    const duration = points && points.length ? Math.max(...points.map(p => p.t), 1) : 1
    const values = points || []
    const maxV = values.length ? Math.max(...values.map(p => p.v)) : 0
    const axisMax = Math.max(110, maxV + 10)

    const toX = t => (t / duration) * 100
    // Drawing space matches the 56-unit viewBox (4 units of top/bottom margin).
    // Y axis starts at 20% of the scale; values below the cutoff hug the baseline.
    const axisMin = 0.2 * axisMax
    const toY = v => Math.min(56, 52 - ((v - axisMin) / (axisMax - axisMin)) * 48)
    const ftpY = toY(100)
    const showFtpTag = ftpY >= 6 && ftpY <= PROFILE_VIEWBOX_Y

    const line = values.map((p, i) => `${i === 0 ? 'M' : 'L'} ${toX(p.t).toFixed(2)} ${toY(p.v).toFixed(2)}`).join(' ')
    const area = values.length
        ? `${line} L 100 56 L 0 56 Z`
        : ''

    return (
        <div className="workout-profile">
            <svg viewBox="0 0 100 56" preserveAspectRatio="none"
                role="img" aria-label="Профиль мощности тренировки">
                <line className="workout-profile__baseline" x1="0" y1="52" x2="100" y2="52" />
                {area && <path className="workout-profile__area" d={area} />}
                {line && <path className="workout-profile__line" d={line} />}
                <line className="workout-profile__ftp" x1="0" y1={ftpY} x2="100" y2={ftpY} />
            </svg>
            {showFtpTag && (
                <span className="workout-profile__ftp-tag"
                    style={{ top: `${(ftpY / PROFILE_VIEWBOX_Y) * 100}%` }}>
                    FTP
                </span>
            )}
        </div>
    )
}